import { FC } from 'react';

import css from './TournamentNameColumn.module.css';

import { ImageButton } from 'v2/components/imageButton/ImageButton';
import { TournamentModel } from 'v2/types/TournamentModel';
import { fileSrc } from 'v2/utils';

interface TournamentNameColumnProps {
  tournament: TournamentModel;
}

export const TournamentNameColumn: FC<TournamentNameColumnProps> = ({ tournament }) => (
  <div className={css.tournamentNameColumn}>
    <ImageButton src={fileSrc(tournament.images.image390Id)} alt={tournament.name} />

    <div>
      <p className={css.tournamentName}>{tournament.name}</p>
    </div>
  </div>
);
